import { inViewport } from './in-viewport';
import { isVisible } from './is-visible';
import { throttle } from './timing';

export function inViewportAndVisible(node, options, callback) {
  return throttle(() => {
    if (
      (options.checkIsVisible && inViewport(node) && isVisible(node)) ||
      (!options.checkIsVisible && inViewport(node))
    ) {
      callback();
    }
  }, options.delay);
}

export function intersectionObserverFallback(node, delay) {
  return new Promise((resolve) => {
    const scrollListener = inViewportAndVisible(node, delay, () => {
      document.removeEventListener('carouselLazyImg', scrollListener);
      window.removeEventListener('scroll', scrollListener);
      window.removeEventListener('resize', scrollListener);
      resolve();
    });

    document.addEventListener('carouselLazyImg', scrollListener, false);
    window.addEventListener('scroll', scrollListener, false);
    window.addEventListener('resize', scrollListener, false);

    scrollListener();
  });
}

/**
 * Create a new IntersectionObserver (or a fallback) and return a Promise which will be resolved when the node is
 * visible in the viewport.
 *
 * @param node
 * @param options
 */
export function intersectionViewportObserver(node, options = {}) {
  const { checkIsVisible = true, delay = 500, threshold = [0.006] } = options;

  /* istanbul ignore else */
  if ('IntersectionObserver' in window) {
    return new Promise((resolve) => {
      const observer = new IntersectionObserver(
        (changes) => {
          changes.forEach((change) => {
            if (change.intersectionRatio > 0) {
              resolve();
              observer.unobserve(node);
            }
          });
        },
        {
          threshold,
        },
      );

      observer.observe(node);
    });
  } else {
    return intersectionObserverFallback(node, { delay, checkIsVisible });
  }
}

/**
 * create a new instance to observer video tag for video lazy load
 * @param {vide elements} videoElementList
 */

function videoIntersectingAction(entries, lazyVideoObserver) {
  entries.forEach(function (video) {
    if (video.isIntersecting) {
      for (const source in video.target.children) {
        const videoSource = video.target.children[source];
        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
          videoSource.src = videoSource.dataset.src;
        }
      }
      video.target.load();
      video.target.classList.remove('video-lazy-bg-load');
      lazyVideoObserver.unobserve(video.target);
    }
  });
}

export function videoLazyObserver(videoElementList) {
  if ('IntersectionObserver' in window) {
    const lazyVideoObserver = new IntersectionObserver(function (entries) {
      videoIntersectingAction(entries, lazyVideoObserver);
    });
    videoElementList.forEach((videoEle) => {
      lazyVideoObserver.observe(videoEle);
    });
  }
}
